import { PayPalScriptProvider } from "@paypal/react-paypal-js"; // prettier-ignore
import { ModalWrapper } from "carbon-components-react";
import { useState } from "react";
import PropTypes from "prop-types";
import React from "react";
import PayPalPaymentButtons from "./PayPalPaymentButtons";

const clientId =
  process.env.NODE_ENV === "production"
    ? "Afa9FphxbUqobdQDFG27X1tLolHmGNVHz79GBYudejBW-yF62BcZBFKntDqSy4B80rFncESTPJfv1aNL"
    : "AU5MxwGrZvAQrceyI-R2mCe-a6nkOIkAMHp56iKX4MuwgySeMWBuqtAS3FMda9_ZnEKvRCvnCVPQLrxM";

const PayPalPaymentModal = ({
  disabled = false,
  onSubmit = () => true,
  onError = () => {},
  totalDonationAmount = "0",
}) => {
  const [submitting, setSubmitting] = useState(false);
  const onApprove = (data, actions) => {
    setSubmitting(true);
    return actions.order
      .capture()
      .then((details) => {
        onSubmit({
          first_name: details.payer.name.given_name,
          last_name: details.payer.name.surname,
          email_address: details.payer.email_address,
          donation_data: details.update_time,
        });
      })
      .catch((error) => {
        onError(error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };
  return (
    <PayPalScriptProvider
      options={{
        "client-id": clientId,
        components: "buttons",
        currency: "USD",
      }}
    >
      <ModalWrapper
        buttonTriggerText="Pay Now"
        disabled={disabled || submitting}
        id="paypal-payment-modal"
        modalHeading="Pay Now"
        passiveModal={true}
        preventCloseOnClickOutside={true}
        shouldCloseAfterSubmit={true}
        shouldSubmitOnEnter={false}
        size="xs"
      >
        <PayPalPaymentButtons
          disabled={submitting}
          fundingSource="paypal"
          onApprove={onApprove}
          onError={onError}
          totalDonationAmount={totalDonationAmount}
        />
        <PayPalPaymentButtons
          disabled={submitting}
          fundingSource="card"
          onApprove={onApprove}
          onError={onError}
          totalDonationAmount={totalDonationAmount}
        />
      </ModalWrapper>
    </PayPalScriptProvider>
  );
};

PayPalPaymentModal.propTypes = {
  disabled: PropTypes.bool,
  onSubmit: PropTypes.func,
  onError: PropTypes.func,
  totalDonationAmount: PropTypes.string,
};

export default PayPalPaymentModal;
